import { render, staticRenderFns } from "./DigitizeBody.vue?vue&type=template&id=7249e6ae&"
import script from "./DigitizeBody.vue?vue&type=script&lang=js&"
export * from "./DigitizeBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports